import { render, staticRenderFns } from "./widget-component-link.vue?vue&type=template&id=db5cf0e0&scoped=true"
import script from "./widget-component-link.vue?vue&type=script&lang=ts"
export * from "./widget-component-link.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5cf0e0",
  null
  
)

export default component.exports